TrelloModel = require 'models/internal/trello-model'

module.exports = class BoardBackground extends TrelloModel
  typeName: 'CustomBoardBackground'



// WEBPACK FOOTER //
// ./app/scripts/models/board-background.coffee